import React from "react";
import PropTypes from "prop-types";
import Check24 from "../../icons/Check24";
import classNames from "../../utils/classNames";
import styles from "./select-option.scss";

export default function SelectOption(props) {
    function handleClick(e) {
        if (!props.disabled) {
            if (typeof props.onClick === "function") {
                props.onClick(e);
            }
        } else {
            e.stopPropagation();
        }
    }
    return (
        <div className={classNames(styles.wrapper, {
            [styles.disabled]: props.disabled
        })} onClick={handleClick} data-selected={props.selected}>
            {props.icon && <div className={styles.icon}>{props.icon}</div>}
            <div className={styles.label}>
                <span>{props.label}</span>
            </div>
            {props.selected && <div className={styles.selected_icon}><Check24 /></div>}
        </div>
    );
};

SelectOption.propTypes = {
    icon: PropTypes.element,
    label: PropTypes.string,
    selected: PropTypes.bool,
    onClick: PropTypes.func,
    disabled: PropTypes.bool
};
